import { MasterSaleFormat } from '../models';
import * as MutationTypes from '../mutationTypes';
import * as api from '@pointOfSale/api';

export const masterSaleFormatListRequest = async ({ commit, getters: { masterSaleFormatList } }, pointOfSaleGuid) => {
  if (masterSaleFormatList.length === 0) {
    const response = await api.masterSaleFormatListRequest(pointOfSaleGuid);
    const masterSaleFormatListRes = MasterSaleFormat.toInstanceList(response.data);
    commit(MutationTypes.MASTER_SALE_FORMAT_LIST_SUCCESS, masterSaleFormatListRes);
  }
  return masterSaleFormatList;
};
